import React from 'react';
import Checkbox from 'apollo-react/components/Checkbox';
import CheckboxGroup from 'apollo-react/components/CheckboxGroup';
import FieldWrapper from '../../fields/FieldWrapper';
import HelperText from '../../fields/HelperText';

const CheckboxFieldInput = ({
  id,
  label,
  value,
  onGroupChange,
  onSingleChange,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  options,
}) => {
  const hasOptions = options && options.length > 0;

  if (hasOptions) {
    return (
      <FieldWrapper style={columnStyle}>
        <CheckboxGroup
          id={id}
          name={id}
          label={label}
          value={value}
          onChange={onGroupChange}
          helperText={helperText}
          error={showError}
          disabled={disabled}
          required={required}
        >
          {options.map((opt) => (
            <Checkbox key={opt.value} value={opt.value} label={opt.label} />
          ))}
        </CheckboxGroup>
      </FieldWrapper>
    );
  }

  return (
    <FieldWrapper style={columnStyle}>
      <Checkbox
        id={id}
        name={id}
        label={label}
        checked={value}
        onChange={onSingleChange}
        disabled={disabled}
        error={showError}
      />
      <HelperText text={helperText} error={showError} />
    </FieldWrapper>
  );
};

export default CheckboxFieldInput;
